/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ provider: NonNullable<unknown> }} Calendar_Connected_AsInputs */

const cs_calendar_connected_as = /** @type {(inputs: Calendar_Connected_AsInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Synchronizace s ${i?.provider}`)
};

const en_calendar_connected_as = /** @type {(inputs: Calendar_Connected_AsInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Syncing with ${i?.provider}`)
};

/**
* | output |
* | --- |
* | "Syncing with {provider}" |
*
* @param {Calendar_Connected_AsInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const calendar_connected_as = /** @type {((inputs: Calendar_Connected_AsInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Calendar_Connected_AsInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_calendar_connected_as(inputs)
	return cs_calendar_connected_as(inputs)
});